const actionTypeIdentifier = '987F99C0-2BEA-4FAE-B5DC-BEFA8610DCF2'; // to generate open ssms run select newid()

export const submitLoginForm = `USER-LOGIN-SUBMIT-LOGIN-FORM-${actionTypeIdentifier}`;
export const getUserScope = `USER-LOGIN-GET-USER-SCOPE-${actionTypeIdentifier}`;
export const getClientScopes = `USER-LOGIN-GET-CLIENT-SCOPES-${actionTypeIdentifier}`;
export const setLoginStatus = `USER-LOGIN-SET-LOGIN-STATUS-${actionTypeIdentifier}`;
export const onSelectClientScope = `USER-LOGIN-CLIENT-SCOPE-SELECTED-${actionTypeIdentifier}`;
export const setAuthedUser = `USER-LOGIN-SET-AUTHED-USER-${actionTypeIdentifier}`;
export const setUiTODetails = `USER-LOGIN-UI-TIMEOUT-DETAILS-${actionTypeIdentifier}`;
export const login = `USER-LOGIN-LOG-IN-APP-${actionTypeIdentifier}`;
export const logout = `USER-LOGIN-LOG-OUT-APP-${actionTypeIdentifier}`;
export const showDataPrivacy = `USER-LOGIN-SHOW-DATA-PRIVACY-${actionTypeIdentifier}`;
export const setUserRoutes = `USER-LOGIN-SET-USER-ROUTES-${actionTypeIdentifier}`;
